export default __webpack_public_path__ + "static/cruwa-small-fed1b85e50090357482688fb138b2d97.png";